import { IS_PRODUCTION_ENVIRONMENT } from '@/constants';

const clarityPromise = IS_PRODUCTION_ENVIRONMENT
  ? import('@microsoft/clarity').then(
      (m: typeof import('@microsoft/clarity')): typeof m.default => m.default,
    )
  : import('@/mocks/mockClarity').then(
      (m: typeof import('@/mocks/mockClarity')): typeof m.default => m.default,
    );

export type ClarityInstance = Awaited<typeof clarityPromise>;

export default clarityPromise;
